import React from "react";
import { BsCheckLg, BsDash, BsX } from "react-icons/bs";
import { AiOutlineBulb, AiOutlineFileText, AiOutlineLink } from "react-icons/ai";

const ComparisonTable = () => {
  const features = [
    { name: "AI Blog Writing", chatgpt: true, yourservice: true },
    { name: "Reddit-Driven Content Ideas", chatgpt: false, yourservice: true },
    { name: "Fully Automated Blog Workflow", chatgpt: false, yourservice: true },
    { name: "Seamlessly Integrates with Other Tools", chatgpt: false, yourservice: true },
    { name: "Keyword-Optimized Content", chatgpt: false, yourservice: true },
    { name: "Identifies Trending Topics", chatgpt: false, yourservice: true },
    { name: "Enhanced Internal Linking Suggestions", chatgpt: false, yourservice: true },
  ];

  const featureIcons = {
    "AI Blog Writing": <AiOutlineFileText className="text-orange-400 text-xl" />,
    "Reddit-Driven Content Ideas": <AiOutlineLink className="text-orange-400 text-xl" />,
    "Fully Automated Blog Workflow": <AiOutlineBulb className="text-orange-400 text-xl" />,
    "Seamlessly Integrates with Other Tools": <AiOutlineLink className="text-orange-400 text-xl" />,
    "Keyword-Optimized Content": <AiOutlineFileText className="text-orange-400 text-xl" />,
    "Identifies Trending Topics": <AiOutlineBulb className="text-orange-400 text-xl" />,
    "Enhanced Internal Linking Suggestions": <AiOutlineLink className="text-orange-400 text-xl" />,
  };

  return (
    <div className="bg-slate-900 py-20 px-4">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl font-bold text-white mb-8 text-center">
          Why Choose <span className="bg-gradient-to-r from-orange-500 to-rose-500">Trendhopper</span> for AI Blogging?
        </h2>
        <div className="bg-slate-800 rounded-lg shadow-lg border border-slate-700">
          {/* Desktop View */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-slate-700">
                  <th className="text-left py-4 px-6 text-slate-400 font-medium text-lg"></th>
                  <th className="text-center py-4 px-6">
                    <span className="text-xl font-semibold text-white">ChatGPT</span>
                  </th>
                  <th className="text-center py-4 px-6">
                    <span className="text-xl font-semibold text-white">Our Service</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {features.map((feature, index) => (
                  <tr
                    key={index}
                    className="border-b border-slate-700 hover:bg-slate-700/50 transition-colors"
                  >
                    <td className="py-4 px-6 text-slate-300 font-medium flex items-center gap-2">
                      {featureIcons[feature.name]} {/* Dynamically render the icon */}
                      {feature.name}
                    </td>
                    <td className="py-4 px-6 text-center">
                      {feature.chatgpt ? (
                        <BsCheckLg className="inline-block text-green-400 text-2xl" />
                      ) : (
                        <BsX className="inline-block text-red-500 text-2xl" />
                      )}
                    </td>
                    <td className="py-4 px-6 text-center">
                      {feature.yourservice ? (
                        <BsCheckLg className="inline-block text-green-400 text-2xl" />
                      ) : (
                        <BsDash className="inline-block text-slate-500 text-2xl" />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Mobile View */}
          <div className="md:hidden">
            {features.map((feature, index) => (
              <div
                key={index}
                className="border-b border-slate-700 p-4 hover:bg-slate-700/50 transition-colors"
              >
                <div className="flex items-center gap-2 mb-4 text-center justify-center">
                  {featureIcons[feature.name]}
                  <span className="text-slate-300 font-medium">{feature.name}</span>
                </div>
                <div className="flex justify-around items-center">
                  <div className="text-center">
                    <span className="text-slate-400 text-sm block">ChatGPT</span>
                    {feature.chatgpt ? (
                      <BsCheckLg className="inline-block text-green-400 text-xl" />
                    ) : (
                      <BsX className="inline-block text-red-500 text-xl" />
                    )}
                  </div>
                  <div className="text-center">
                    <span className="text-slate-400 text-sm block">Our Service</span>
                    {feature.yourservice ? (
                      <BsCheckLg className="inline-block text-green-400 text-xl" />
                    ) : (
                      <BsDash className="inline-block text-slate-500 text-xl" />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonTable;
